// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M13.834 12.5273H10.165L12 8.55273L13.834 12.5273Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 22H2V2H22V22ZM10.9756 6L5.67285 17.4893L7.48926 18.3271L9.24219 14.5273H14.7568L16.5107 18.3271L18.3271 17.4893L13.0244 6H10.9756Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-mode-text-filled')
export default class ModeTextFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mode-text-filled',
    }
  }
}
